import { ArrowUpRight } from "lucide-react";
import { NEWS } from "../../data/content";
import { Reveal, Eyebrow } from "./Reveal";

export default function News() {
  return (
    <section
      id="news"
      data-testid="news-section"
      className="border-b border-[var(--line)] bg-white"
    >
      <div className="mx-auto max-w-[1400px] px-6 py-28 md:px-10 md:py-40">
        {/* Masthead */}
        <Reveal>
          <div className="rule-double flex items-center justify-between pt-5">
            <Eyebrow testid="news-eyebrow">{NEWS.eyebrow}</Eyebrow>
            <span className="hidden font-mono text-[11px] uppercase tracking-[0.24em] text-[#5c6474] sm:block">
              Press Room — Clippings File
            </span>
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-10 max-w-3xl font-display text-4xl font-light tracking-tight text-[#1c2b4a] md:text-5xl lg:text-6xl">
            {NEWS.heading}
          </h2>
        </Reveal>

        {/* Front page feature */}
        <Reveal delay={0.12}>
          <a
            href={NEWS.featured.href}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="news-featured"
            className="group mt-14 grid overflow-hidden rounded-sm border border-[var(--line)] bg-[#faf8f5] transition-colors duration-500 hover:border-[#9c7a33]/50 lg:grid-cols-12"
          >
            <div className="relative h-72 overflow-hidden lg:col-span-5 lg:h-auto">
              <img
                src={NEWS.featured.image}
                alt={NEWS.featured.title}
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <span className="absolute left-5 top-5 rounded-sm bg-[#9c7a33] px-3 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-[#f7f1ea]">
                {NEWS.featured.source} · {NEWS.featured.kicker}
              </span>
            </div>
            <div className="flex flex-col justify-between p-8 md:p-12 lg:col-span-7">
              <div>
                <span className="font-mono text-[11px] uppercase tracking-[0.24em] text-[#9c7a33]">
                  Above the fold
                </span>
                <h3 className="mt-4 font-display text-3xl leading-tight text-[#1c2b4a] md:text-5xl">
                  {NEWS.featured.title}
                </h3>
                <p className="mt-5 max-w-xl text-base leading-relaxed text-[#5c6474] md:text-lg">
                  {NEWS.featured.blurb}
                </p>
              </div>
              <span className="mt-8 inline-flex items-center gap-2 text-sm uppercase tracking-[0.16em] text-[#1c2b4a] transition-colors group-hover:text-[#9c7a33]">
                Read the feature <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
              </span>
            </div>
          </a>
        </Reveal>

        {/* Clippings grid */}
        <div className="mt-6 grid gap-px overflow-hidden rounded-sm border border-[var(--line)] bg-[var(--line)] sm:grid-cols-2 lg:grid-cols-4">
          {NEWS.items.map((n, i) => (
            <Reveal key={n.href} delay={0.05 + i * 0.06}>
              <a
                href={n.href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`news-item-${i}`}
                className="group flex h-full flex-col justify-between gap-10 bg-white p-7 transition-colors duration-500 hover:bg-[#faf8f5]"
              >
                <div>
                  <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#9c7a33]">
                    {n.source}
                  </span>
                  <h4 className="mt-3 font-display text-xl leading-snug text-[#1c2b4a]">
                    {n.title}
                  </h4>
                </div>
                <span className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.16em] text-[#5c6474] transition-colors group-hover:text-[#9c7a33]">
                  Read clipping <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
                </span>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
